var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideNoDeviceNoAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#EE9C23",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76904 8.0005C4.76904 6.21609 6.2156 4.76953 8.00001 4.76953C9.78443 4.76953 11.231 6.21609 11.231 8.0005C11.231 9.78492 9.78443 11.2315 8.00001 11.2315C6.2156 11.2315 4.76904 9.78492 4.76904 8.0005Z",
    fill: "#EE9C23",
    fillOpacity: 0.913725
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideNoDeviceNoAsset);
export default __webpack_public_path__ + "static/media/guide-no-device-no-asset.74feddade96776ffc5728e6f3a92e4e3.svg";
export { ForwardRef as ReactComponent };